import * as z from "zod";

export const workflowSuggestionSchema = z.object({
  suggestion: z
    .object({
      title: z.string().trim().min(1).max(120),
      reason: z
        .string()
        .trim()
        .min(1)
        .max(300)
        .describe("Why the user would benefit from repeating this process"),
      inputs: z
        .string()
        .trim()
        .min(1)
        .max(300)
        .describe(
          "The data or parameters each run needs, grounded in the chat"
        ),
      trigger: z
        .string()
        .trim()
        .min(1)
        .max(200)
        .describe(
          "The requested trigger or cadence, or manual if none was requested"
        ),
      steps: z.array(z.string().trim().min(1).max(300)).min(1).max(8),
    })
    .nullable()
    .describe(
      "A concrete reusable process, or null to withdraw an earlier suggestion"
    ),
});

type SuggestionEntry = {
  entryType: string;
  toolCall?: {
    toolName: string;
    input: unknown;
    completedAt: number | null;
    isError: boolean | null;
  } | null;
};

export function latestWorkflowSuggestion(entries: readonly SuggestionEntry[]) {
  for (let index = entries.length - 1; index >= 0; index--) {
    const entry = entries[index];
    const call = entry?.toolCall;
    if (
      entry?.entryType !== "AssistantToolUse" ||
      call?.toolName !== "setWorkflowSuggestion" ||
      call.completedAt == null ||
      call.isError
    )
      continue;
    const parsed = workflowSuggestionSchema.safeParse(call.input);
    if (parsed.success) return parsed.data.suggestion;
  }
  return null;
}
